import { BankOutlined } from '@ant-design/icons';
import { FormItemProps, SelectProps } from 'antd';
import { TaskDef, findTaskDefByAgent } from '../../apis/mgmt/api';
import { DataOptionProps, DataSelect, DataFormItem, DataSelectProps } from '../common/DataSelect';


export const TaskDefOptionProps: DataOptionProps<TaskDef> = {
    valueFromData: (data) => data?.id,
    labelFromData: (data) => data?.name,
};

const TaskDefSelect = function<TFilter>(props: DataSelectProps<TaskDef,TFilter>) {
    return (
        <DataSelect<TaskDef,TFilter>
            placeholder="TaskDef"
            suffixIcon={<BankOutlined className="site-form-item-icon" />}
            dataOptionsProps={TaskDefOptionProps}
            {...props}
        />
    );
}

export const TaskDefFormItem = (props: FormItemProps<any>) => 
    <DataFormItem<TaskDef>
        {...props}
        dataOptionsProps={TaskDefOptionProps}
    />
;

export const AgentTaskDefSelect = (props: SelectProps<any> & { agentDefId?: string }) => {
    const { agentDefId, ...selectProps } = props;
    return (
        <TaskDefSelect<string>
            {...selectProps}
            searchFilter={props.agentDefId}
            search ={ async (searchText: string, agentDefId?: string) => {
                if (!agentDefId) return [];
                const result = await findTaskDefByAgent({agentId: agentDefId, size: 100});
                return result.data.content || [];
            }}
        />
    );
}
